//A card component that displays a jobsite's information. 

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FiMapPin, FiLogIn, FiLogOut } from 'react-icons/fi';

// Dispatchable actions from the currentJobsiteSlice
import { setNextPunchType } from '../../features/currentJobsite/currentJobsiteSlice';

const WorkerJobsite = ({ jobSite, onImageClick }) => {
  // Augmented fields provided by parent (WorkerDash):
  
  const distanceKm = jobSite.distanceAway; // km
  const isWithinRadius = jobSite.isWithinRadius; // boolean
  
  // workerLocation no longer needed here for distance math
  const { workerId, language } = useSelector((state) => state.workerAuth.workerUser);
  const { empSubStatus , workerUser } = useSelector((state) => state.workerAuth);
  const { clockedInData, clockedOutData, jobsite: currentJobsite } = useSelector((state) => state.currentJobsite);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Check if workerId is in the foremen array
  const isForeman = jobSite.foremen?.some(f => f.id === workerId);

  

  // Executes the routing when button is clicked
  const handlePunchBtn = () => {
    navigate(`/punch/${jobSite.id}`);
  };

  const handleIconClick = (punchType) => {
    dispatch(setNextPunchType(punchType));
    handlePunchBtn();
  };

  const convertToLocalTime = (utcTime) => {
    if (!utcTime) {
      return "No";
    }
    const date = new Date(utcTime);
    return date.toLocaleTimeString(); // Converts to local time string, only time portion
  };

  return (
    <>
      {/* Title */}
      <div className="mb-0">
       <h1 className="text-left text-2xl font-semibold tracking-tight text-stone-900">
          {isForeman && (
            <span className="mr-1 text-amber-500">★</span>
          )}
          {jobSite.jobsiteName}

          {distanceKm !== null && distanceKm !== undefined && (
            <span className="ml-1 text-sm font-normal text-stone-500">
              {distanceKm * 0.621371 < 1
              ? ` (${Math.round(distanceKm * 3280.84)} ft)`
              : ` (${(distanceKm * 0.621371).toFixed(2)} mi)`}
            </span>
          )}
        </h1>
      </div>

      {/* Image */}
      <div className="mt-1 mb-6">
        <img
          src={jobSite.s3URL}
          alt={jobSite.jobsiteName}
          className="mb-2 h-48 w-full cursor-pointer rounded-xl border border-stone-200 object-cover"
          onClick={isForeman && onImageClick ? onImageClick : undefined}
        />
      </div>

      {/* Address */}
      <div className="flex justify-center mb-2">
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(jobSite.address)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-xs text-stone-600 underline decoration-dotted transition hover:text-stone-900"
        >
          <FiMapPin className="mr-1 text-base text-rose-500" />
          {jobSite.address}
        </a>
      </div>

      {/* Notes */}
      {jobSite.siteNotes && (
        <div className="max-h-32 overflow-y-auto rounded-xl border border-stone-200 bg-stone-50 p-3">
          {Object.entries(jobSite.siteNotes).map(([key, value], index) => (
            <div key={index} className="mb-2">
              <p className="text-left text-sm font-semibold text-stone-700">• {key}:</p>
              <p className="text-left text-sm text-stone-600">{value}</p>
            </div>
          ))}
        </div>
      )}

      {/* Icons with Clickable Functionality */}
      {currentJobsite?.id === jobSite.id && (
        (empSubStatus === 'active' || empSubStatus === 'trialing') ? (
          <div className="flex justify-around mt-4">
            {/* Clock In Button */}
            <button
              className={`flex flex-col items-center rounded-lg bg-green-600 px-4 py-2 text-sm text-white shadow-sm transition hover:bg-green-700 ${
                !clockedInData && isWithinRadius ? "animate-pulse" : ""
              } disabled:opacity-50 disabled:cursor-not-allowed`}
              onClick={() => handleIconClick("clockIn")}
              disabled={!isWithinRadius || clockedInData}
            >
              <FiLogIn className="mx-auto mb-1 text-white" size={22} />
              <p>{clockedInData ? convertToLocalTime(clockedInData) : (language === 'Spa' ? 'Entrada' : 'Clock In')}</p>
            </button>

            {/* Clock Out Button */}
            <button
              className={`flex flex-col items-center rounded-lg bg-red-600 px-4 py-2 text-sm text-white shadow-sm transition hover:bg-red-700 ${
                clockedInData && !clockedOutData && isWithinRadius ? "animate-pulse" : ""
              } disabled:opacity-50 disabled:cursor-not-allowed`}
              onClick={() => handleIconClick("clockOut")}
              disabled={!isWithinRadius || !clockedInData || clockedOutData}
            >
             <FiLogOut className="mx-auto mb-1 text-white" size={22} />
              <p>{clockedOutData ? convertToLocalTime(clockedOutData) : (language === 'Spa' ? 'Salida' : 'Clock Out')}</p>
            </button>
          </div>
        ) : (
         <div className="mt-4 rounded-md bg-rose-50 px-2 py-2 text-center text-sm font-medium text-rose-600">
            Contact Administrator : {workerUser?.adminName}
        </div>
        )
      )}
    </>
  );
};

export default WorkerJobsite;
